<td class="pia-listsBlock-item">
  <div class="pia-listsBlock-item-actions">
    <a
      [routerLink]="['/knowledge_bases', base.id]"
      class="btn pia-tooltip"
      *ngIf="!base.is_example; else elseblock"
    >
      <fa-icon [icon]="faPencil"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.edit' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.edit" | translate }}</span
      >
    </a>
    <ng-template #elseblock>
      <a [routerLink]="['/knowledge_bases', base.id]" class="btn pia-tooltip">
        <fa-icon [icon]="faEye"></fa-icon>
        <span
          title="{{ 'homepage.cards.item.consult_pia' | translate }}"
          class="pia-tooltip-text"
          >{{ "homepage.lists.item.tools.consult" | translate }}</span
        >
      </a>
    </ng-template>
    <a
      href="javascript:;"
      (click)="export(base.id)"
      class="btn pia-tooltip"
      *ngIf="!base.is_example"
    >
      <fa-icon [icon]="faDownload"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.export' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.export" | translate }}</span
      >
    </a>
    <a
      href="javascript:;"
      (click)="duplicate(base.id)"
      class="btn pia-tooltip"
      *ngIf="!base.is_example"
    >
      <fa-icon [icon]="faFile"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.duplicate' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.duplicate" | translate }}</span
      >
    </a>
    <a
      href="javascript:;"
      (click)="remove(base.id)"
      class="btn pia-tooltip"
      *ngIf="!base.is_example"
    >
      <fa-icon [icon]="faTrash"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.remove' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.remove" | translate }}</span
      >
    </a>
  </div>
</td>
<td class="pia-listsBlock-item">
  <div
    contenteditable
    (focusout)="onFocusOut('name', $event)"
    *ngIf="!base.is_example; else readOnlyName"
  >
    {{ base.name }}
  </div>
  <ng-template #readOnlyName>
    <div>{{ base.name }}</div>
  </ng-template>
</td>
<td class="pia-listsBlock-item">
  <div
    contenteditable
    (focusout)="onFocusOut('author', $event)"
    *ngIf="!base.is_example; else readOnlyName"
  >
    {{ base.author }}
  </div>
  <ng-template #readOnlySectorName>
    <div>{{ base.author }}</div>
  </ng-template>
</td>
<td class="pia-listsBlock-item">
  <div
    contenteditable
    (focusout)="onFocusOut('contributors', $event)"
    *ngIf="!base.is_example; else readOnlyName"
  >
    {{ base.contributors }}
  </div>
  <ng-template #readOnlySectorName>
    <div>{{ base.contributors }}</div>
  </ng-template>
</td>
<td class="pia-listsBlock-item">
  <div>{{ nbEntries }}</div>
</td>
